import { prefixerT } from '.'

export const ROUTE_GENERAR_ALERTA_FECHA_ZARPE = prefixerT('generar-alerta-fecha-zarpe')
